import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import DashboardNewModal from 'modules/reports/components/DashboardNewModal'

const DashboardNewModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.reports.dashboards.list.fullPath())
  }

  const onSuccess = (dashboardId: number) => {
    navigate(navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: dashboardId }))
  }

  return <DashboardNewModal onClose={onClose} onSuccess={onSuccess} />
}

export default DashboardNewModalPage
